import { AnalyticsEvent } from "../models";

export class CancelOrderVisibleEvent implements AnalyticsEvent {
  name = 'CancelOrderVisibleEvent';

  constructor() { }
}